import { round } from "lodash"

// Calculations for loan
export function calculate(pr: number, int: number, mo: number) {
  // Get the user's input from the form. Assume it is all valid.
  // Convert interest from a percentage to a decimal, and convert from
  // an annual rate to a monthly rate. Convert payment period in years
  // to the number of monthly payments.
  const principal = pr
  const interest = int / 100 / 12
  const payments = mo

  // Now compute the monthly payment figure, using esoteric math.
  const x = Math.pow(1 + interest, payments)
  const monthly = (principal * x * interest) / (x - 1)

  // Check that the result is a finite number. If so, display the results.
  return round(monthly)
  // Otherwise, the user's input was probably invalid, so don't
  // display anything.
}

//Calculates loan amount using by months with monthly payment
export function calculateLoanAmount(
  monthlyPayment: number,
  annualInterestRate: number,
  loanTermInYears: number
): number {
  const monthlyInterestRate = annualInterestRate / 12 / 100
  const totalNumberOfPayments = loanTermInYears * 12
  const presentValue =
    monthlyPayment *
    ((1 - Math.pow(1 + monthlyInterestRate, -totalNumberOfPayments)) /
      monthlyInterestRate)
  return presentValue
}

export function isBetween(value, first, last) {
  const lower = Math.min(first, last),
    upper = Math.max(first, last)
  return value >= lower && value <= upper
}
